import React, { useState } from "react";
import { Popup, Button } from "semantic-ui-react";
import { isFunction } from "lodash";
import { Confirm } from "./Confirm";

export const ActionButton = ({
  submitAction,
  resetAction,
  confirmMsg=null,
  showConfirmation=false,
  resetText="Cancel",
  submitText="Save",
  widths= "1",
  resetHide=true,
  negativeAction=false,
  disabled = false,
}) => {

  const [currentState, setCurrentState] = useState(false);
  const handleConfirm = () => {
    submitAction();
    setCurrentState(false);
  };

  const getConfirmMsg = () => {
    if (isFunction(confirmMsg))
      return confirmMsg();
    return confirmMsg;
  };

  return (
    <Button.Group widths={widths}>
        {showConfirmation ? (
          <Popup
            on="click"
            trigger={
              <Button
                id="submit-button"
                primary
                type="submit"
                negative={negativeAction}
                disabled={disabled}
                onClick={() => setCurrentState(true)}
                style={{backgroundColor: "var(--add)"}}
              >{submitText}</Button>
            }
            content={
              <Confirm
                confirmMsg={getConfirmMsg()}
                handleConfirm={handleConfirm}
                handleDeny={() => setCurrentState(false)}
              />
            }
            onOpen={() => {setCurrentState(true)}}
            open={currentState}
          >
          </Popup>
        ) : (
          <Button
            id="submit-button"
            primary
            type="submit"
            onClick={() => submitAction()}
          >{submitText}</Button>
        )}
        {!resetHide && (<Button.Or/>)}
        {!resetHide && (<Button
          type="button"
          onClick={resetAction}
      >{resetText}</Button> )}
    </Button.Group>
  );
};
